<div
    class="percentage-container between-center"
    [ngStyle]="{ background: color }"
    [ngClass]="{ 'between-center': percentage !== 0, center: percentage === 0 }"
>
    <img
        *ngIf="percentage !== 0"
        src="assets/icons/up-arrow.svg"
        class="arrow-icon"
        [ngClass]="{ 'direction-down': decreasing }"
    />
    <p class="percentage-text" *ngIf="comparisionValue !== 0">{{ percentage }}%</p>
    <p class="percentage-text" *ngIf="comparisionValue === 0">{{ fallbackValue }}</p>
</div>
